import { Outlet } from 'react-router-dom';

/** 海报列表与画布编辑子路由 */
export default function PostersLayout() {
  return (
    <div className="flex h-full min-h-0 flex-col overflow-hidden">
      <Outlet />
    </div>
  );
}
